import React from 'react';
import { observer } from 'mobx-react-lite';
// import { useStores } from '../../../hooks';
// import PropTypes from 'prop-types';
// import { Route, Redirect, useRouteMatch, useHistory } from 'react-router-dom';
import { createBrowserHistory } from 'history';

// import { createQueryParamModalHelpers } from '../../../shared/utils/queryParamModal';
// import { Modal } from '../index';
import { Container } from './Styles';
import Item from './Item';
import { Version } from '../../Version/index';

const SideNavContainer = observer(
  ({
    auctionList,
    currentAuctionId,
    laneList,
    currentLaneId,
    runList,
    currentLotNumber,
    userList,
    handleAuctionChange,
    handleLaneChange,
    totalBiddersInLane,
    handleOpenItemClick,
  }) => {
    const history = createBrowserHistory({ forceRefresh: true });
    // const summaryModalHelpers = createQueryParamModalHelpers('summary-view');
    // const handleAuctionClick=()=>{
    //       history.push("/auctions/")
    // }

    // const handleTranscriptReportClick=()=>{
    //     history.push("/auctionTranscriptReport/")
    // }
    return (
      <>
        <Container>
          <Version />
          {/* <Item
                    onClick={summaryModalHelpers.open}
                    icon="fa-pie-chart"
                    text="Summary"
                /> */}
          {/* <Item
                    // onClick={prefsModalHelpers.open}
                    icon="fa-users"
                    text="Accounts"
                    badge="2"
                /> */}
          <Item
            testid="sidenav-auctions"
            onClick={() => history.push('/auctions/')}
            icon="fa-calendar"
            text="Auctions"
          />
          <Item
            testid="sidenav-transcript"
            onClick={() => history.push('/auctionTranscriptReport/')}
            icon="fa fa-file-excel-o"
            text="Transcript Report"
          />
          <Item
            testid="sidenav-tools"
            onClick={() => history.push('/engineAdmin/')}
            icon="fa fa-code"
            text="Engine Tools"
          />
          {/* <Item
                    // onClick={prefsModalHelpers.open}
                    icon="fa-certificate"
                    text="Marketings"
                /> */}
          {/* <Item
                    // onClick={prefsModalHelpers.open}
                    icon="fa-dollar"
                    text="Sales"
                /> */}
          {/* <Item
                    // onClick={prefsModalHelpers.open}
                    icon="fa-motorcycle"
                    text="Inventory"
                /> */}
          {/* <Item
                    // onClick={prefsModalHelpers.open}
                    icon="fa-cog"
                    text="Settings"
                /> */}
        </Container>
        {/* 
            {summaryModalHelpers.isOpen() && (
                <Modal
                    isOpen
                    testid="modal:summary-view"
                    variant="center"
                    width={500}
                    height={400}
                    onClose={summaryModalHelpers.close}
                    renderContent={() => (
                        <div style={{ marginLeft: "10px", fontWeight:'bold' }}>Summary coming soon</div>
                        // <Summary auctionList={auctionList} laneList={laneList} />
                    )}
                />
            )} */}
      </>
    );
  },
);

export default SideNavContainer;
